<template>
    <div class="chosen check mb-3 flex items-center justify-between cursor-pointer">
        <span class="flex-grow flex flex-col">
            <cUtilsEdit @edit="goToConsentTypeField(type, 'consentTypeName')">
                <span
                    :style="{ color: cookie.textColor, 'font-family': cookie.fontFamily }"
                    class="flex items-center text-sm font-medium text-left whitespace-pre-line"
                    id="availability-label"
                >
                    {{ label }}
                    <span v-if="info" :data-info="info" class="check-info">
                        <InformationCircleIcon class="h-4 w-4 opacity-50" />
                    </span>
                </span>
            </cUtilsEdit>
        </span>
        <button
            v-if="!text"
            type="button"
            class="check-bg ml-2 relative inline-flex flex-shrink-0 h-5 w-9 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200"
            role="switch"
            aria-checked="false"
            aria-labelledby="availability-label"
            aria-describedby="availability-description"
        >
            <span
                aria-hidden="true"
                class="check-circle pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
            ></span>
        </button>
        <span class="check-label" v-else>{{ text }}</span>
    </div>
</template>

<script>
import { InformationCircleIcon } from "@easy/ui/icons";
import { useCookieGoTo } from "@/views/tools/cookie/utils/useCookieGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "CookieCheck",
    components: {
        InformationCircleIcon,
        cUtilsEdit,
    },
    props: {
        text: String,
        label: String,
        info: String,
        cookie: Object,
        type: String,
    },
    setup() {
        const { goToConsentTypeField } = useCookieGoTo();
        return {
            goToConsentTypeField,
        };
    },
};
</script>

<style lang="scss" scoped>
.check {
    .check-info {
        position: relative;
        padding: 4px;
        &:before {
            content: attr(data-info);
            position: absolute;
            bottom: 8px;
            font-size: 0.9em;
            padding: 2px 4px;
            display: none;
            width: 20rem;
            transform: translateX(-5rem);
            color: white;
            background: rgba(0, 0, 0, 0.85);
            border-radius: 4px;
            z-index: 99;
            text-align: left;
        }

        &:hover:before {
            display: inline-block;
        }
    }

    .check-circle {
        --tw-translate-x: 0;
    }
    .check-bg {
        background-color: #e5e7eb;
    }

    &.chosen {
        .check-circle {
            --tw-translate-x: 1rem;
        }
        .check-bg {
            background-color: #249455;
        }
    }

    .check-label {
        padding: 2px 8px;
        border-radius: 12px;
        background-color: #249455;
        color: white;
    }
}
</style>
